import React, { Component } from 'react';
import '../../css/pages/agents.css';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import iconSprite from '../../assets/icon-sprite.svg';
import { createUser } from '../actions/account';

class CreateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleOnChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleSubmit = (e) => {
    e.preventDefault();
    const { onSubmit, history } = this.props;
    this.setState({ loading: 'Processing' }, async () => {
      try {
        const response = await createUser(this.state);
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message, {
          onClose: () => {
            history.push('/users');
          },
        });
        onSubmit?.();
      } catch (error) {
        this.setState({ processing: false },
          () => toast.error(error.response?.data?.message || error.response?.statusText
            || error.message
            || 'Seems like something went wrong with your request. Please try again.'));
      } finally {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { loading } = this.state;

    return (
      <>
        <SideNav />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav />
            <section className="body-main__content">
              <div className="pageTitle pageTitle--main">
                <a href="agents.html" className="btn-with-navig d-inline-flex justify-content-center align-items-center d-lg-none">
                  <div className="icon">
                    <svg width="20" height="20">
                      <use xlinkHref={`${iconSprite}#go-back`}></use>
                    </svg>
                  </div>
                  <p>Back to Users</p>
                </a>
              </div>
              <main className="create-agent__main">
                <div className="create-agent__main--container">
                  <div className="create-agent__text">
                    <h3 className="create-agent__text--header">
                      Create a User.
                    </h3>
                    <p className="create-agent__text--subheader">
                      Enter the details of the user.
                    </p>
                  </div>
                  <div className="default-card create-agent__form">
                    <div className="create-agent__form-title">
                      <p>Basic info</p>
                    </div>
                    <form action="" onSubmit={this.handleSubmit}>
                      <div>
                        <div className="form-group">
                          <label htmlFor="first_name" className="form-label">First Name</label>
                          <input
                            type="first_name"
                            className="form-control"
                            name="first_name"
                            id="first_name"
                            onChange={this.handleOnChange} />
                          <div className="form-text error-message">
                            <p>First Name is required. </p>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="last_name" className="form-label">Last Name</label>
                          <input
                            type="last_name"
                            className="form-control"
                            name="last_name"
                            id="last_name"
                            onChange={this.handleOnChange} />
                          <div className="form-text error-message">
                            <p>Last Name is required.</p>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="phone_number" className="form-label">Phone Number</label>
                          <input
                            type="number"
                            className="form-control"
                            name="phone_number"
                            id="phone_number"
                            onChange={this.handleOnChange} />
                          <div className="form-text error-message">
                            <p>Phone Number is required.</p>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="email" className="form-label">Email Address</label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            id="email"
                            onChange={this.handleOnChange} />
                          <div className="form-text error-message">
                            <p>Email Address is required.</p>
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="type" className="form-label">Type</label>
                          <div className="input-with-icon">
                            <select className="form-control" id="type">
                              {/* <option disabled selected>Select</option> */}
                              <option selected>Initiator</option>
                            </select>
                            <span className="input-icon">
                              <svg width="24" height="24">
                                <use xlinkHref="../../assets/icon-sprite.svg#dropdown"></use>
                              </svg>
                            </span>
                          </div>
                          <div className="form-text error-message">
                            <p>User type is required.</p>
                          </div>
                        </div>
                      </div>
                      <button
                        type="submit"
                        className="btn btn-primary w-50 mx-2 mt-4"
                        disabled={loading}>
                        {loading || 'Create User'}
                      </button>
                    </form>
                  </div>
                </div>
              </main>
            </section>
          </div>
        </main>
      </>
    );
  }
}

export default connect(
)(CreateUser);
